import React, { Component } from 'react';
import Header from './components/header';
import Slider from './components/home/slider'
import Produce from './components/home/produce';
import AboutUs from './components/home/aboutUs';
import Consult from './components/home/consult';
import News from './components/home/news'
import Partner from './components/home/partner';
// import Suggest from './components/home/suggest';
// import Project from './components/home/project'
import Footer from './components/footer'




export class Home extends Component {
  // constructor() {
  //   super();
  //   const script = document.createElement("script");

  //   script.src = "http://apafan.ir/assets/js/script.js";

  //   document.body.appendChild(script);
  // }

  componentDidMount() {

    //  alert('ffff')
    // const { home } = this.props.location;

    // if (!home) return this.props.history.push('/');

    window.scrollTo(0, 0)







  }

  render() {

    return (
      <div className="page-wrapper">


        <div className="preloader">
          <div className="preloader-inner">
            <img src="assets/images/preloader.gif" alt='' role='presentation' />
          </div>
        </div>



        <Header />
        <Slider />
        <AboutUs />
        <Produce />
        <News />
        <Consult BackgroundVisible={true} />
        <Partner />


        {/* <Suggest />
        <Project /> */}

        <Footer />


      </div >


    );
  }
}
export default Home;